import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    marginLeft: 10,
    height: '100%'
  }
})
